export const HUNT_DAYS = [
  ["2026-10-02", "Ven 2 oct. — Arrivée"],
  ["2026-10-03", "Sam 3 oct."],
  ["2026-10-04", "Dim 4 oct."],
  ["2026-10-05", "Lun 5 oct."],
  ["2026-10-06", "Mar 6 oct."],
  ["2026-10-07", "Mer 7 oct."],
  ["2026-10-08", "Jeu 8 oct."],
  ["2026-10-09", "Ven 9 oct. — Dernier jour"],
  ["2026-10-10", "Sam 10 oct. — Retour"],
];

export function dayLabel(iso) {
  return HUNT_DAYS.find(([id]) => id === iso)?.[1] || iso;
}
